import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import PleaseWaitContextProvider from './context/PleaseWaitContextProvider.js';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <PleaseWaitContextProvider>
          <App />
     </PleaseWaitContextProvider>
    </AuthProvider>
  </React.StrictMode>
);

